module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/logo-7b1bc10745656a9156a166ccf4901a8c.png";